import React, { useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination, Autoplay } from 'swiper/modules';
import { get } from "../helper/helper_api"
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaShieldAlt, FaUserSecret, FaClipboardCheck, FaCheckCircle, FaLock, FaGlobe, FaArrowRight } from 'react-icons/fa';
import HomeVideo from '../assets/images/home-video-2.mp4';
import serviceImage from '../assets/images/industry.webp';
import Customer from '../component/Client';
import FeaturedProject from '../component/FeaturedProject';
import FooterContact from '../component/FooterContact';


export default function Home() {
    const [data, setData] = useState([]);
    const [error, setError] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        getData();
    }, [])

    const getData = () => {
        get("/home")
            .then(json => {
                console.log('response from get home list', error);
                if (json?.statusCode == 200) {
                    setData(json?.data);
                } else {
                    setError(true);
                }
            })
            .catch(error => {
                console.log('error while getting home list', error);
            })
    }

    const parseTitle = (title) => {
        const url = title.toLowerCase().replace(/[^a-z0-9]+/g, '-');
        return url;
    }

    const backgroundImageStyle = {
        backgroundImage: `url(${serviceImage})`,
        backgroundSize: 'cover',
    };

    return (
        <>
            <div className='banner-section' style={{ backgroundColor: '#0B0F19', minHeight: '100vh', display: 'flex', alignItems: 'center', position: 'relative', overflow: 'hidden' }}>

                {/* Animated Background Elements for Cyber Theme */}
                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, overflow: 'hidden', zIndex: 0 }}>
                    <div style={{ position: 'absolute', top: '-10%', left: '-10%', width: '40%', height: '40%', borderRadius: '50%', background: 'radial-gradient(circle, rgba(96,165,250,0.15) 0%, rgba(11,15,25,0) 70%)', filter: 'blur(40px)' }}></div>
                    <div style={{ position: 'absolute', bottom: '-20%', right: '-10%', width: '60%', height: '60%', borderRadius: '50%', background: 'radial-gradient(circle, rgba(167,139,250,0.1) 0%, rgba(11,15,25,0) 70%)', filter: 'blur(60px)' }}></div>
                </div>

                <div className='padding-left-right w-100 d-flex flex-column justify-content-center h-100 container' style={{ zIndex: 1, paddingTop: '100px', paddingBottom: '50px', position: 'relative' }}>
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-12 text-left mb-5 mb-lg-0">
                            <div className="mb-3">
                                <span className="badge badge-pill badge-primary text-uppercase px-3 py-2" style={{ backgroundColor: 'rgba(59, 130, 246, 0.1)', color: '#60A5FA', border: '1px solid rgba(59, 130, 246, 0.3)', display: 'inline-block' }}>● CYBERSECURITY SOLUTIONS</span>
                            </div>
                            <h1 className='font-weight-bold mb-4 banner-title-mobile' style={{ color: '#fff', fontSize: 'clamp(2rem, 5vw, 3.5rem)', lineHeight: '1.2', display: 'block' }}>
                                <span style={{ color: '#60A5FA' }}>SECURE YOUR,</span><br />
                                Digital Future With Expert Protection
                            </h1>
                            <p className='mb-4' style={{ color: '#9CA3AF', fontSize: '1rem', maxWidth: '600px', display: 'block' }}>Cyber Fortify is a proactive cybersecurity firm delivering advanced threat detection, vulnerability assessments, and comprehensive managed security services.</p>
                            <div className="d-flex flex-wrap align-items-center gap-3 mt-4" style={{ display: 'flex' }}>
                                <Link to="/contact-us" className="btn btn-primary px-4 py-3 mr-3 mb-2" style={{ backgroundColor: '#6366F1', border: 'none', borderRadius: '8px', fontWeight: 'bold' }}>Connect Now ►</Link>
                                <Link to="/about" className="btn btn-outline-light px-4 py-3 mb-2" style={{ border: '1px solid #4B5563', borderRadius: '8px', color: '#E5E7EB', backgroundColor: 'transparent' }}>View Case Studies</Link>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                            <motion.div
                                className="bnr-card"
                                initial={{ opacity: 0, x: 40 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.8, delay: 0.2 }}
                            >
                                {/* Top shield badge */}
                                <div className="bnr-card-top">
                                    <div className="bnr-shield-wrap">
                                        <FaShieldAlt className="bnr-shield-icon" />
                                        <div className="bnr-shield-ring bnr-ring-1" />
                                        <div className="bnr-shield-ring bnr-ring-2" />
                                    </div>
                                    <p className="bnr-card-eyebrow">DEFENSE-GRADE SECURITY</p>
                                    <h3 className="bnr-card-headline">Trusted by Fortune 100<br />Companies Worldwide</h3>
                                </div>

                                {/* Divider */}
                                <div className="bnr-divider" />

                                {/* 3 stats in a row */}
                                <div className="bnr-stats-row">
                                    {[
                                        { value: '1,200+', label: 'Threats Mitigated', color: '#60A5FA' },
                                        { value: '5', label: 'Security Centers', color: '#34D399' },
                                        { value: '99%', label: 'Client Retention', color: '#FBBF24' },
                                    ].map((s, i) => (
                                        <div key={i} className="bnr-stat-item">
                                            <span className="bnr-stat-value" style={{ color: s.color }}>{s.value}</span>
                                            <span className="bnr-stat-label">{s.label}</span>
                                        </div>
                                    ))}
                                </div>

                                {/* Divider */}
                                <div className="bnr-divider" />

                                {/* Trusted by row */}
                                <div className="bnr-trusted-row">
                                    <span className="bnr-trusted-label">TRUSTED BY</span>
                                    <div className="bnr-trusted-badges">
                                        {['AT&T', 'Boeing', 'Burberry', 'Coles'].map(name => (
                                            <span key={name} className="bnr-trusted-badge">{name}</span>
                                        ))}
                                    </div>
                                </div>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </div>

            <section class="about-section about-animat">
                <div class="container">
                    <div class="row clearfix">

                        <div class="content-column col-lg-6 col-sm-12 col-xs-12">
                            <div class="inner-column">
                                <div class="sec-title">
                                    <div class="title">CYBER FORTIFY TECHNOLOGES</div>
                                    <h2 className='text-white'>Company Overview</h2>
                                </div>
                                <div class="para_text3">Founded in 2023, we are committed to making cybersecurity accessible, reliable, and effective for organizations of all sizes. Our experienced team provides end-to-end cybersecurity solutions designed to identify vulnerabilities, mitigate risks, and strengthen digital resilience.</div><br />
                                <div class="para_text3">Our comprehensive services include Managed SOC, Vulnerability Assessment & Penetration Testing (VAPT), Risk Assessment, Digital Forensics, and other proactive security solutions. We combine industry expertise, advanced security practices, and a proactive approach to help organizations protect their systems, data, and digital infrastructure against evolving cyber threats.</div>
                                <Link to="/about" class="theme-btn btn-style-three">Read More</Link>
                            </div>
                        </div>

                        <div class="image-column col-lg-6 col-sm-12 col-xs-12">
                            <div class="inner-column " data-wow-delay="0ms" data-wow-duration="1500ms">
                                <div class="image">
                                    <img src={require('../assets/images/home-about.webp')} alt="" />
                                    <div class="overlay-box">
                                        <div class="year-box"><span class="number">4+</span>Years <br /> Experience <br /> Working</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <section className="svc-grid-section">
                <div className="container">
                    {/* Header */}
                    <motion.div
                        initial={{ opacity: 0, y: -24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.7 }}
                        viewport={{ once: true }}
                        className="svc-grid-header"
                    >
                        <div className="svc-grid-header-left">
                            <span className="svc-grid-badge">Our Services</span>
                            <h2 className="svc-grid-title">
                                We Offer Best <span className="svc-grid-title-accent">Cyber Security</span> Solutions
                            </h2>
                        </div>
                        <p className="svc-grid-subtitle">
                            All cyber security solutions under one roof, where we detect every single vulnerability before it harms your organization and help you meet your compliance.
                        </p>
                    </motion.div>

                    {/* 3x2 Image Overlay Grid */}
                    <div className="svc-grid">
                        {[
                            { to: '/services/network-penertration', img: require('../assets/images/services/website-testing.webp'), title: 'Network Penetration Testing', desc: 'Simulate real attacks to uncover vulnerabilities in your network infrastructure.' },
                            { to: '/services/web-application-penetration', img: require('../assets/images/services/vulnerability.webp'), title: 'Web App Penetration Testing', desc: 'Deep dive into your web application to identify and fix critical security flaws.' },
                            { to: '/services/vulnerability-assessment', img: require('../assets/images/services/compilance.webp'), title: 'VAPT', desc: 'Comprehensive vulnerability assessment and penetration testing in one engagement.' },
                            { to: '/services/mobile-app', img: require('../assets/images/services/mobile-app-testing.webp'), title: 'Mobile App Penetration Testing', desc: 'iOS and Android security testing following the OWASP Mobile Top 10 standard.' },
                            { to: '/services/managed-security', img: require('../assets/images/services/managed-security.webp'), title: 'Managed Security Services', desc: 'Round-the-clock monitoring and management of your entire security environment.' },
                            { to: '/services/iso-27001', img: require('../assets/images/services/iso.webp'), title: 'ISO 27001 Consulting', desc: 'Expert guidance to achieve and maintain ISO 27001 information security certification.' },
                        ].map((svc, i) => (
                            <motion.div
                                key={i}
                                className="svc-grid-item"
                                initial={{ opacity: 0, y: 40 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.6, delay: i * 0.08 }}
                                viewport={{ once: true }}
                            >
                                <Link to={svc.to} className="svc-grid-link">
                                    {/* Background image */}
                                    <img src={svc.img} alt={svc.title} className="svc-grid-img" />
                                    {/* Always-visible gradient overlay */}
                                    <div className="svc-grid-overlay" />
                                    {/* Arrow icon top-right */}
                                    <div className="svc-grid-arrow">
                                        <FaArrowRight />
                                    </div>
                                    {/* Bottom content */}
                                    <div className="svc-grid-content">
                                        <h3 className="svc-grid-name">{svc.title}</h3>
                                        <p className="svc-grid-desc">{svc.desc}</p>
                                    </div>
                                </Link>
                            </motion.div>
                        ))}
                    </div>

                    {/* CTA */}
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.3 }}
                        viewport={{ once: true }}
                        className="svc-grid-cta"
                    >
                        <Link to="/services" className="svc-grid-cta-btn">
                            See All Services <FaArrowRight className="svc-grid-cta-icon" />
                        </Link>
                    </motion.div>
                </div>
            </section>

            <FeaturedProject />

            <section style={{ backgroundColor: '#060B14', padding: '100px 0', position: 'relative', overflow: 'hidden' }}>
                {/* Background glow blobs */}
                <div style={{ position: 'absolute', top: '-80px', left: '-80px', width: '400px', height: '400px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(59,130,246,0.08) 0%, transparent 70%)', pointerEvents: 'none' }} />
                <div style={{ position: 'absolute', bottom: '-80px', right: '-80px', width: '500px', height: '500px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(99,102,241,0.07) 0%, transparent 70%)', pointerEvents: 'none' }} />

                <div className='container' style={{ position: 'relative', zIndex: 1 }}>
                    <div className='row align-items-center g-5'>

                        {/* Left -- visual panel */}
                        <div className="col-lg-5">
                            <motion.div
                                initial={{ opacity: 0, x: -40 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.8 }}
                                style={{ position: 'relative' }}
                            >
                                {/* Main shield card */}
                                <div style={{ background: 'linear-gradient(135deg, #0F172A 0%, #1E293B 100%)', border: '1px solid rgba(59,130,246,0.2)', borderRadius: '24px', padding: '48px 36px', textAlign: 'center', position: 'relative', overflow: 'hidden' }}>
                                    <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '2px', background: 'linear-gradient(90deg, transparent, #3B82F6, #6366F1, transparent)' }} />
                                    <FaShieldAlt style={{ fontSize: '7rem', color: '#3B82F6', filter: 'drop-shadow(0 0 32px rgba(59,130,246,0.6))', marginBottom: '24px' }} />
                                    <div style={{ color: '#60A5FA', fontSize: '0.75rem', fontWeight: '700', letterSpacing: '3px', textTransform: 'uppercase', marginBottom: '8px' }}>DEFENSE-GRADE SECURITY</div>
                                    <div style={{ color: '#F1F5F9', fontSize: '1.5rem', fontWeight: '700', lineHeight: '1.3' }}>Trusted by Fortune 100<br />Companies Worldwide</div>
                                </div>

                                {/* Floating stat badges */}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginTop: '16px' }}>
                                    {[
                                        { value: '1,200+', label: 'Threats Mitigated', color: '#3B82F6' },
                                        { value: '99%', label: 'Client Retention', color: '#10B981' },
                                        { value: '4+', label: 'Years Experience', color: '#A78BFA' },
                                        { value: '24/7', label: 'Active Monitoring', color: '#FBBF24' },
                                    ].map((stat, i) => (
                                        <motion.div
                                            key={i}
                                            initial={{ opacity: 0, y: 20 }}
                                            whileInView={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.5, delay: 0.1 * i }}
                                            style={{ background: '#0F172A', border: '1px solid #1E293B', borderRadius: '14px', padding: '16px', textAlign: 'center' }}
                                        >
                                            <div style={{ color: stat.color, fontSize: '1.5rem', fontWeight: '800', lineHeight: 1 }}>{stat.value}</div>
                                            <div style={{ color: '#64748B', fontSize: '0.75rem', marginTop: '4px' }}>{stat.label}</div>
                                        </motion.div>
                                    ))}
                                </div>
                            </motion.div>
                        </div>

                        {/* Right -- content */}
                        <div className='col-lg-7'>
                            <motion.div
                                initial={{ opacity: 0, x: 40 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.8 }}
                            >
                                <div style={{ color: '#3B82F6', fontSize: '0.75rem', fontWeight: '700', letterSpacing: '3px', textTransform: 'uppercase', marginBottom: '16px' }}>
                                    ● ABOUT CYBER FORTIFY TECH
                                </div>
                                <h2 style={{ color: '#F1F5F9', fontSize: 'clamp(1.8rem, 3.5vw, 2.8rem)', fontWeight: '800', lineHeight: '1.2', marginBottom: '24px' }}>
                                    Protecting What Matters<br />
                                    <span style={{ color: '#3B82F6' }}>Most to Your Business</span>
                                </h2>

                                <p style={{ color: '#94A3B8', fontSize: '1rem', lineHeight: '1.8', marginBottom: '32px' }}>
                                    We help companies safeguard their digital assets from black hat hackers. Our expert team of ethical hackers, strategists, and consultants collaborate to create a robust security system that is virtually impenetrable -- providing proactive monitoring, threat detection, and customized solutions to ensure the integrity of your most valuable information.
                                </p>

                                {/* Feature list */}
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', marginBottom: '40px' }}>
                                    {[
                                        { icon: <FaCheckCircle />, color: '#10B981', text: 'Recognized and trusted by Fortune 100 companies including Walmart, Tesla, and Intel.' },
                                        { icon: <FaGlobe />, color: '#3B82F6', text: 'Comprehensive cybersecurity solutions covering VAPT, SOC, compliance, and digital forensics.' },
                                        { icon: <FaLock />, color: '#A78BFA', text: 'Zero-trust frameworks and AI-driven threat intelligence active around the clock.' },
                                    ].map((item, i) => (
                                        <motion.div
                                            key={i}
                                            initial={{ opacity: 0, x: 20 }}
                                            whileInView={{ opacity: 1, x: 0 }}
                                            transition={{ duration: 0.5, delay: 0.15 * i }}
                                            style={{ display: 'flex', alignItems: 'flex-start', gap: '14px', background: '#0F172A', border: '1px solid #1E293B', borderRadius: '12px', padding: '16px 20px' }}
                                        >
                                            <span style={{ color: item.color, fontSize: '1.1rem', marginTop: '2px', flexShrink: 0 }}>{item.icon}</span>
                                            <p style={{ color: '#CBD5E1', fontSize: '0.9rem', lineHeight: '1.6', margin: 0 }}>{item.text}</p>
                                        </motion.div>
                                    ))}
                                </div>

                                <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                                    <Link to="/contact" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', backgroundColor: '#3B82F6', color: '#fff', padding: '14px 28px', borderRadius: '10px', fontWeight: '700', fontSize: '0.9rem', textDecoration: 'none', border: 'none', transition: 'background 0.2s' }}>
                                        Get Protected Now <span style={{ fontSize: '0.8rem' }}>►</span>
                                    </Link>
                                    <Link to="/about" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', backgroundColor: 'transparent', color: '#CBD5E1', padding: '14px 28px', borderRadius: '10px', fontWeight: '600', fontSize: '0.9rem', textDecoration: 'none', border: '1px solid #1E293B' }}>
                                        Learn More About Us
                                    </Link>
                                </div>
                            </motion.div>
                        </div>

                    </div>
                </div>
            </section>

            <section className='service-section'>
                {/* <img src={require('../assets/images/bg-tr.png')} alt='bg' className='bg-banner' /> */}
                <div className='service-child-section'>
                    <div className='container'>
                        <motion.div
                            initial={{ opacity: 0, y: -30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8 }}
                            className='header-title text-center'
                        >
                            <h6 className='sub-heading'>HOW WE DO IT</h6>
                            <h2 className='heading'>Our Protocols</h2>
                            <p className='paragraph' style={{ color: '#e0dcdc' }}>Our continuously refined protocols enable a thorough and adaptive analysis built on experience.<br /> <strong>31,296+ VULNERABILITIES PATCHED DAILY</strong></p>
                        </motion.div>
                        <div className='row mt-5'>
                            <div className='col-md-4 mb-4'>
                                <motion.div
                                    whileHover={{ y: -10, boxShadow: '0 10px 30px rgba(0,0,0,0.5)' }}
                                    initial={{ opacity: 0, y: 50 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.5, delay: 0.1 }}
                                    className='protocol-box h-100 p-4 border border-secondary rounded bg-dark border-opacity-25'
                                >
                                    <div className="icon-wrapper mb-4 text-center">
                                        <FaShieldAlt className="text-info fs-1" />
                                    </div>
                                    <h4 className='text-center mb-3 text-white'>Assess & Audit</h4>
                                    <p className='text-light text-center'>Identifying the right approach is crucial. A thorough diagnosis is essential to predict potential outcomes. It becomes even more effective with expert analysts on board. We have them, and they're highly skilled at mapping complex digital environments.</p>
                                </motion.div>
                            </div>
                            <div className='col-md-4 mb-4'>
                                <motion.div
                                    whileHover={{ y: -10, boxShadow: '0 10px 30px rgba(0,0,0,0.5)' }}
                                    initial={{ opacity: 0, y: 50 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.5, delay: 0.3 }}
                                    className='protocol-box h-100 p-4 border border-secondary rounded bg-dark border-opacity-25'
                                >
                                    <div className="icon-wrapper mb-4 text-center">
                                        <FaUserSecret className="text-warning fs-1" />
                                    </div>
                                    <h4 className='text-center mb-3 text-white'>Penetrate (Ethical)</h4>
                                    <p className='text-light text-center'>Figuring it out is the key. A robust diagnosis is essential to predict potential outcomes. It becomes even more powerful with professional ethical hackers on board. We have them, and they're exceptional at finding zero-day loopholes before bad actors do.</p>
                                </motion.div>
                            </div>
                            <div className='col-md-4 mb-4'>
                                <motion.div
                                    whileHover={{ y: -10, boxShadow: '0 10px 30px rgba(0,0,0,0.5)' }}
                                    initial={{ opacity: 0, y: 50 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.5, delay: 0.5 }}
                                    className='protocol-box h-100 p-4 border border-secondary rounded bg-dark border-opacity-25'
                                >
                                    <div className="icon-wrapper mb-4 text-center">
                                        <FaClipboardCheck className="text-success fs-1" />
                                    </div>
                                    <h4 className='text-center mb-3 text-white'>Secure & Report</h4>
                                    <p className='text-light text-center'>Diagnosis and testing may sound impressive, but it's equally important to patch issues and explain it in simple terms. Our team ensures that findings are clearly communicated, and robust mitigations are instantly deployed.</p>
                                </motion.div>
                            </div>

                            <div className='col-lg-12 col-md-12 col-sm-12 mt-5'>
                                <motion.div
                                    initial={{ opacity: 0, scale: 0.9 }}
                                    whileInView={{ opacity: 1, scale: 1 }}
                                    transition={{ duration: 0.8 }}
                                    className='stories-section text-center'
                                >
                                    <img src="https://www.suntechnologies.com/wp-content/uploads/2021/03/image-1-updated-01_cropped.png" alt='Workflow' className="img-fluid rounded shadow-lg" />
                                </motion.div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Testimonials section */}
            <section className='bottom top padding-left-right' style={{ backgroundColor: '#101218' }}>
                <div className='container'>
                    <h4 className='heading wow fadeInUp text-center' style={{ color: 'white' }}>TESTIMONIALS</h4>
                    <Swiper
                        spaceBetween={30}
                        pagination={{
                            clickable: true,
                        }}
                        breakpoints={{
                            640: {
                                slidesPerView: 2,
                                spaceBetween: 20,
                            },
                            768: {
                                slidesPerView: 2,
                                spaceBetween: 20,
                            },
                            1024: {
                                slidesPerView: 2,
                                spaceBetween: 20,
                            },
                            1440: {
                                slidesPerView: 2,
                                spaceBetween: 20,
                            },
                        }}
                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                        }}
                        modules={[Pagination, Autoplay]}
                        className="testimonialSwiper"
                    >
                        <SwiperSlide>
                            <div className='slider_container'>
                                <div className='slider_3'>
                                    <div className='slider-para wow fadeInUp'>
                                        "Cyber Fortify has been a game-changer for our organization. Their thorough vulnerability assessments and proactive security strategies have ensured that our networks and data are protected at all times. The team is highly knowledgeable, and their quick response to any potential threats has greatly enhanced our security posture. We trust them with all our cybersecurity needs!"
                                    </div>
                                    <h6 className='wow fadeInUp'>JOHN MATTHEW</h6>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className='slider_container'>
                                <div className='slider_3'>
                                    <div className='slider-para wow fadeInUp'>
                                        "Working with Cyber Fortify has been an incredibly positive experience. Their tailored solutions helped us identify and address gaps in our security infrastructure. The team's professionalism and expertise are unmatched, and their support has been invaluable in keeping our sensitive information safe. I highly recommend Cyber Fortify to any business looking to improve its cybersecurity."                                </div>
                                    <h6 className='wow fadeInUp'>EMMA DAVIS</h6>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className='slider_container'>
                                <div className='slider_3'>
                                    <div className='slider-para wow fadeInUp'>
                                        "Cyber Fortify has delivered exceptional service in securing our business. Their security audits were thorough, and they provided us with clear, actionable recommendations that we could implement immediately. Their team is highly responsive and always available to answer any questions. Thanks to Cyber Fortify, we now have a robust and reliable cybersecurity system in place."                                </div>
                                    <h6 className='wow fadeInUp'>MICHAEL JOHNSON</h6>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className='slider_container'>
                                <div className='slider_3'>
                                    <div className='slider-para wow fadeInUp'>
                                        "As a company focused on protecting sensitive data, we rely heavily on Cyber Fortify to keep our systems secure. Their comprehensive threat analysis and rapid incident response have been key to maintaining a secure environment. Their experts go above and beyond to ensure we're always one step ahead of potential threats. Highly recommend their services!"                                </div>
                                    <h6 className='wow fadeInUp'>MANISH YADAV</h6>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className='slider_container'>
                                <div className='slider_3'>
                                    <div className='slider-para wow fadeInUp'>
                                        "Cyber Fortify has been instrumental in enhancing our company's cybersecurity strategy. Their team took the time to understand our unique needs and provided customized solutions that truly made a difference. We've seen a significant reduction in security risks since partnering with them. Their attention to detail and proactive approach make them a trusted partner in cybersecurity."
                                    </div>
                                    <h6 className='wow fadeInUp'>DAVID LEE</h6>
                                </div>
                            </div>
                        </SwiperSlide>
                    </Swiper>
                </div>
            </section>

            <section style={{ position: 'relative', overflow: 'hidden', padding: '100px 0' }}>
                {/* Full background image with dark overlay */}
                <div style={{
                    position: 'absolute', inset: 0,
                    backgroundImage: `url(${require('../assets/images/security-banner.webp')})`,
                    backgroundSize: 'cover', backgroundPosition: 'center',
                    backgroundAttachment: 'fixed',
                    zIndex: 0,
                }} />
                {/* Multi-layer dark overlay */}
                <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(135deg, rgba(3,7,18,0.93) 0%, rgba(6,11,30,0.88) 50%, rgba(3,7,18,0.95) 100%)', zIndex: 1 }} />
                {/* Blue glow top-left */}
                <div style={{ position: 'absolute', top: '-100px', left: '-100px', width: '500px', height: '500px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(59,130,246,0.12) 0%, transparent 70%)', zIndex: 1, pointerEvents: 'none' }} />
                {/* Purple glow bottom-right */}
                <div style={{ position: 'absolute', bottom: '-100px', right: '-100px', width: '600px', height: '600px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(99,102,241,0.1) 0%, transparent 70%)', zIndex: 1, pointerEvents: 'none' }} />

                <div className='container' style={{ position: 'relative', zIndex: 2 }}>
                    {/* Section header */}
                    <motion.div
                        initial={{ opacity: 0, y: -30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.7 }}
                        className='text-center'
                        style={{ marginBottom: '60px' }}
                    >
                        <span style={{ display: 'inline-block', backgroundColor: 'rgba(59,130,246,0.1)', color: '#60A5FA', border: '1px solid rgba(59,130,246,0.3)', borderRadius: '20px', padding: '6px 20px', fontSize: '12px', fontWeight: '700', letterSpacing: '3px', textTransform: 'uppercase', marginBottom: '16px' }}>
                            WHY CHOOSE US
                        </span>
                        <h2 style={{ color: '#F1F5F9', fontSize: 'clamp(1.8rem, 4vw, 2.8rem)', fontWeight: '800', lineHeight: '1.2', margin: '0 auto 16px' }}>
                            What Sets Us <span style={{ color: '#3B82F6' }}>Apart</span>
                        </h2>
                        <p style={{ color: '#64748B', fontSize: '1rem', maxWidth: '520px', margin: '0 auto' }}>
                            Enterprise-grade cybersecurity built on expertise, speed, and relentless protection.
                        </p>
                    </motion.div>

                    {/* Cards grid */}
                    <div className='row g-4'>
                        {[
                            {
                                img: require('../assets/images/support/hours.webp'),
                                title: 'Perfection Anytime',
                                desc: 'Advanced cybersecurity solutions protecting digital assets with expert analysts and 24/7 monitoring. We ensure your business stays secure against evolving cyber threats.',
                                accent: '#3B82F6',
                                delay: 0.1,
                            },
                            {
                                img: require('../assets/images/support/support.webp'),
                                title: '24/7 Response Center',
                                desc: 'Rapid incident response and support, ensuring constant protection and immediate reaction to any cybersecurity threats at all times.',
                                accent: '#10B981',
                                delay: 0.2,
                            },
                            {
                                img: require('../assets/images/support/fleet.webp'),
                                title: 'Global Intelligence',
                                desc: 'Global network of cybersecurity professionals using cutting-edge threat intelligence for proactive threat hunting and continuous monitoring.',
                                accent: '#A78BFA',
                                delay: 0.3,
                            },
                            {
                                img: require('../assets/images/support/call.webp'),
                                title: 'Emergency Mitigation',
                                desc: 'Reactive containment solutions with 24/7 emergency incident response, real-time forensic analysis, and advanced recovery from active breaches.',
                                accent: '#F59E0B',
                                delay: 0.4,
                            },
                            {
                                img: require('../assets/images/support/advance-tech.webp'),
                                title: 'Zero-Trust Architecture',
                                desc: 'Zero-Trust frameworks delivering top-tier internal security, preventing lateral malware movement with compliance-grade protection against all risks.',
                                accent: '#EC4899',
                                delay: 0.5,
                            },
                            {
                                img: require('../assets/images/support/officer.webp'),
                                title: 'Certified Experts',
                                desc: 'Globally certified experts (CISSP, CEH, CISM) providing enterprise-grade governance, risk management, and security architecture for your infrastructure.',
                                accent: '#06B6D4',
                                delay: 0.6,
                            },
                        ].map((card, i) => (
                            <div key={i} className='col-lg-4 col-md-6'>
                                <motion.div
                                    initial={{ opacity: 0, y: 40 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.6, delay: card.delay }}
                                    whileHover={{ y: -8, transition: { duration: 0.25 } }}
                                    style={{
                                        background: 'rgba(10, 16, 30, 0.75)',
                                        border: `1px solid rgba(255,255,255,0.07)`,
                                        borderTop: `3px solid ${card.accent}`,
                                        borderRadius: '16px',
                                        padding: '32px 28px',
                                        height: '100%',
                                        backdropFilter: 'blur(12px)',
                                        WebkitBackdropFilter: 'blur(12px)',
                                        transition: 'box-shadow 0.25s',
                                        cursor: 'default',
                                    }}
                                    onMouseEnter={e => e.currentTarget.style.boxShadow = `0 20px 50px rgba(0,0,0,0.5), 0 0 0 1px ${card.accent}33`}
                                    onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}
                                >
                                    {/* Icon with accent glow bg */}
                                    <div style={{ width: '64px', height: '64px', borderRadius: '14px', background: `${card.accent}18`, border: `1px solid ${card.accent}33`, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '24px' }}>
                                        <img
                                            src={card.img}
                                            alt={card.title}
                                            style={{ width: '36px', height: '36px', objectFit: 'contain', filter: 'brightness(0) invert(1)', opacity: 0.9 }}
                                        />
                                    </div>

                                    {/* Accent line */}
                                    <div style={{ width: '32px', height: '2px', background: card.accent, borderRadius: '2px', marginBottom: '14px' }} />

                                    <h3 style={{ color: '#F1F5F9', fontSize: '1.1rem', fontWeight: '700', marginBottom: '12px', lineHeight: '1.3' }}>
                                        {card.title}
                                    </h3>
                                    <p style={{ color: '#64748B', fontSize: '0.9rem', lineHeight: '1.75', margin: 0 }}>
                                        {card.desc}
                                    </p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <Customer />

            <section className="cft-intel-section">
                <div className="cft-intel-bg-glow cft-intel-glow-left"></div>
                <div className="cft-intel-bg-glow cft-intel-glow-right"></div>
                <div className="container">
                    <div className="row align-items-center cft-intel-row">

                        {/* Left -- content */}
                        <div className="col-lg-6 col-md-12">
                            <motion.div
                                initial={{ opacity: 0, x: -40 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.8 }}
                                viewport={{ once: true }}
                            >
                                <span className="cft-intel-badge">
                                    <FaShieldAlt className="cft-intel-badge-icon" />
                                    CYBER FORTIFY TECHNOLOGIES
                                </span>
                                <h2 className="cft-intel-heading">
                                    Cyber Fortify<br />
                                    <span className="cft-intel-heading-accent">Tech Intelligence</span>
                                </h2>
                                <div className="cft-intel-divider"></div>
                                <p className="cft-intel-para">
                                    Elevate your business with Cyber Fortify's cutting-edge cybersecurity services. As an award-winning cybersecurity consultant, we offer comprehensive solutions tailored to protect your digital assets and strengthen your overall security framework.
                                </p>
                                <p className="cft-intel-para">
                                    Let us transform the way you secure your business, ensuring that your systems, data, and transactions remain protected from ever-evolving cyber threats.
                                </p>

                                {/* Feature pills */}
                                <div className="cft-intel-pills">
                                    {['24/7 Monitoring', 'Zero-Trust Defense', 'AI Threat Detection', 'Compliance Ready'].map((tag) => (
                                        <span key={tag} className="cft-intel-pill">{tag}</span>
                                    ))}
                                </div>

                                <div className="cft-intel-actions">
                                    <Link to="/contact-us" className="cft-intel-btn-primary">
                                        Get Protected Now <FaArrowRight className="cft-intel-btn-icon" />
                                    </Link>
                                    <Link to="/services" className="cft-intel-btn-outline">
                                        View Services
                                    </Link>
                                </div>
                            </motion.div>
                        </div>

                        {/* Right -- image */}
                        <div className="col-lg-6 col-md-12">
                            <motion.div
                                initial={{ opacity: 0, x: 40 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.8, delay: 0.15 }}
                                viewport={{ once: true }}
                                className="cft-intel-img-wrap"
                            >
                                <div className="cft-intel-img-border-tl"></div>
                                <div className="cft-intel-img-border-br"></div>
                                <img
                                    src={require('../assets/images/expertise.avif')}
                                    alt="Cyber Fortify SOC"
                                    className="cft-intel-img"
                                />
                                {/* Floating stat card */}
                                <div className="cft-intel-stat-card">
                                    <FaShieldAlt className="cft-intel-stat-icon" />
                                    <div>
                                        <div className="cft-intel-stat-value">1,200+</div>
                                        <div className="cft-intel-stat-label">Threats Neutralized</div>
                                    </div>
                                </div>
                            </motion.div>
                        </div>

                    </div>
                </div>
            </section>

            {/* ── INDUSTRIES WE SERVE ── */}
            <section style={{ backgroundColor: '#060B14', padding: '90px 0', position: 'relative', overflow: 'hidden' }}>
                {/* Background glow orbs */}
                <div style={{ position: 'absolute', top: '-100px', left: '10%', width: '500px', height: '500px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(59,130,246,0.06) 0%, transparent 70%)', pointerEvents: 'none' }} />
                <div style={{ position: 'absolute', bottom: '-80px', right: '10%', width: '400px', height: '400px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(99,102,241,0.07) 0%, transparent 70%)', pointerEvents: 'none' }} />

                <div className="container" style={{ position: 'relative', zIndex: 1 }}>
                    {/* Section header */}
                    <div style={{ textAlign: 'center', marginBottom: '60px' }}>
                        <span style={{ display: 'inline-block', background: 'rgba(59,130,246,0.12)', border: '1px solid rgba(59,130,246,0.3)', color: '#60A5FA', borderRadius: '20px', padding: '6px 20px', fontSize: '12px', fontWeight: '700', letterSpacing: '3px', textTransform: 'uppercase', marginBottom: '16px' }}>
                            SECTORS WE PROTECT
                        </span>
                        <h2 style={{ color: '#F1F5F9', fontSize: 'clamp(1.8rem, 3.5vw, 2.6rem)', fontWeight: '800', lineHeight: '1.2', margin: 0 }}>
                            Industries We <span style={{ background: 'linear-gradient(135deg, #3B82F6, #6366F1)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Serve</span>
                        </h2>
                        <p style={{ color: '#64748B', fontSize: '1rem', marginTop: '14px', maxWidth: '520px', margin: '14px auto 0', lineHeight: '1.7' }}>
                            Cyber Fortify delivers tailored security solutions across every major sector in the UAE and beyond.
                        </p>
                    </div>

                    {/* Industry cards grid */}
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: '16px' }}>
                        {[
                            { img: require('../assets/images/industries/New Project.webp'), label: 'Games & Gambling', color: '#F59E0B', glow: 'rgba(245,158,11,0.15)' },
                            { img: require('../assets/images/industries/2.webp'), label: 'Critical Infrastructure', color: '#EF4444', glow: 'rgba(239,68,68,0.15)' },
                            { img: require('../assets/images/industries/3.png'), label: 'Banking & Financial', color: '#10B981', glow: 'rgba(16,185,129,0.15)' },
                            { img: require('../assets/images/industries/4.webp'), label: 'Health Care', color: '#EC4899', glow: 'rgba(236,72,153,0.15)' },
                            { img: require('../assets/images/industries/5.webp'), label: 'Online Services', color: '#3B82F6', glow: 'rgba(59,130,246,0.15)' },
                            { img: require('../assets/images/industries/6.webp'), label: 'Retail', color: '#A78BFA', glow: 'rgba(167,139,250,0.15)' },
                            { img: require('../assets/images/industries/7.webp'), label: 'Media & Advertising', color: '#06B6D4', glow: 'rgba(6,182,212,0.15)' },
                            { img: require('../assets/images/industries/8.webp'), label: 'E-commerce', color: '#F97316', glow: 'rgba(249,115,22,0.15)' },
                            { img: require('../assets/images/industries/9.webp'), label: 'Telecom', color: '#6366F1', glow: 'rgba(99,102,241,0.15)' },
                            { img: require('../assets/images/industries/10.webp'), label: 'Alternative Assets', color: '#14B8A6', glow: 'rgba(20,184,166,0.15)' },
                            { img: require('../assets/images/industries/11.webp'), label: 'Transportation', color: '#3B82F6', glow: 'rgba(59,130,246,0.15)' },
                            { img: require('../assets/images/industries/12.webp'), label: 'Legal', color: '#F59E0B', glow: 'rgba(245,158,11,0.15)' },
                            {
                                svg: (
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" style={{ width: '100%', height: '100%' }}>
                                        <path d="M3 21h18M3 7l9-4 9 4M4 7v14M20 7v14M8 11v4M12 11v4M16 11v4" />
                                    </svg>
                                ), label: 'Government & Public Sector', color: '#38BDF8', glow: 'rgba(56,189,248,0.15)'
                            },
                            {
                                svg: (
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" style={{ width: '100%', height: '100%' }}>
                                        <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
                                    </svg>
                                ), label: 'Energy & Oil', color: '#FB923C', glow: 'rgba(251,146,60,0.15)'
                            },
                        ].map((industry, i) => (
                            <div
                                key={i}
                                style={{
                                    background: 'rgba(10,16,30,0.8)',
                                    border: '1px solid rgba(255,255,255,0.06)',
                                    borderRadius: '16px',
                                    padding: '28px 16px 22px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: '14px',
                                    cursor: 'default',
                                    transition: 'transform 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease',
                                    backdropFilter: 'blur(10px)',
                                }}
                                onMouseEnter={e => {
                                    e.currentTarget.style.transform = 'translateY(-6px)';
                                    e.currentTarget.style.borderColor = industry.color + '55';
                                    e.currentTarget.style.boxShadow = `0 20px 50px rgba(0,0,0,0.4), 0 0 0 1px ${industry.color}22, inset 0 0 40px ${industry.glow}`;
                                }}
                                onMouseLeave={e => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.borderColor = 'rgba(255,255,255,0.06)';
                                    e.currentTarget.style.boxShadow = 'none';
                                }}
                            >
                                {/* Icon wrapper with glow bg */}
                                <div style={{
                                    width: '72px', height: '72px', borderRadius: '16px',
                                    background: industry.glow,
                                    border: `1px solid ${industry.color}33`,
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    padding: '14px',
                                    transition: 'background 0.25s ease',
                                }}>
                                    {industry.svg ? (
                                        <span style={{ width: '100%', height: '100%', color: industry.color, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            {industry.svg}
                                        </span>
                                    ) : (
                                        <img
                                            src={industry.img}
                                            alt={industry.label}
                                            style={{
                                                width: '100%', height: '100%', objectFit: 'contain',
                                                filter: `brightness(0) saturate(100%) invert(1)`,
                                                opacity: 0.9,
                                            }}
                                        />
                                    )}
                                </div>
                                {/* Label */}
                                <p style={{
                                    color: '#CBD5E1', fontSize: '13px', fontWeight: '600',
                                    textAlign: 'center', margin: 0, lineHeight: '1.4',
                                    letterSpacing: '0.01em',
                                }}>
                                    {industry.label}
                                </p>
                                {/* Bottom accent line */}
                                <div style={{ width: '24px', height: '2px', background: industry.color, borderRadius: '2px', opacity: 0.7 }} />
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className='achievement-section top bottom' style={{ backgroundColor: '#0F172A' }}>
                <div className='container'>
                    <div className='row'>
                        <div className="col-12 wow fadeInUp" >
                            <div className="h-100 overflow-hidden">
                                <iframe className="w-100" style={{ height: '400px' }} src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d29550169.802498687!2d44.76129718375484!3d25.297535361859616!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f5deefa716dfb%3A0x457f02604d9940a!2sAl%20Sayegh%20Building!5e0!3m2!1sen!2sin!4v1728109484054!5m2!1sen!2sin"
                                    loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <FooterContact />

        </>
    )
}
